
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPathsResult, GetStaticPropsContext } from 'next';
import Page from 'components/Page';
import { getV1PropsSlugPage } from 'lib/page-props/getV1Props';
import DeprecatedLayout from 'components/DeprecatedLayout';
import { getV2PropsSlugPage } from 'lib/page-props/getV2Props';
import LayoutComponent from '_components/LayoutComponent';
import Breadcrumb from '_components/Breadcrumb';
import CookieBanner from '_components/CookieBanner';
import { fontFamilyMap } from './_app';
import HeaderMeta from 'components/Layout/HeaderMeta';
import clsx from 'clsx';
import FaviconHead from 'components/FaviconHead';
import BackToTop from 'components/Layout/BackToTop';
import Zalo from 'components/Layout/ZaloWidget'; // Ensure this path is correct
import { hideZaloPages } from 'lib/constants';
import FloatingWidget from 'components/Layout/FloatingWidget';
interface SlugPageProps {
    locale: 'th' | 'en' | 'vi' | 'id' | 'en-PH' | 'en-SG' | 'en-MY';
    tenant: string;
    page: any;
    hrefLang?: any;
    layout?: any;
    breadcrumbs?: any[];
    settings?: any;
}
function SlugPage(props: SlugPageProps) {
    if (props.tenant !== 'asiadirect' &&
        (props.locale === 'th' || props.locale === 'en')) {
        return (<DeprecatedLayout {...props}>
        <FaviconHead tenant={props.tenant}/>
        <Page page={props.page} hrefLang={props.hrefLang}/>
      </DeprecatedLayout>);
    }
    const { page, locale, breadcrumbs, layout, settings } = props;
    const shouldShowZalo = page?.slug && !hideZaloPages.includes(page?.slug);
    return (<div style={{ fontFamily: fontFamilyMap[locale] }} className={clsx(props.tenant === 'asiadirect' && 'theme-adb')}>
      <LayoutComponent tenant={props.tenant} navigations={layout.navigation.map((nav: any) => ({
            text: nav.title,
            url: nav.linkUrl,
            subcategory: nav.subcategory.map((sub: any) => ({
                text: sub.title,
                url: sub.link,
            })),
        }))} contact={{
            phone: settings.phone,
            openingHours: settings.openingTimes,
            lineUrl: settings.lineUrl,
            messengerUrl: settings.messengerUrl,
        }} footer={{
            content: layout.footer.content,
            links: layout.footer.links,
            logo: layout.footer.logo,
        }} locale={layout.locale || ''}>
        {breadcrumbs && breadcrumbs.length > 0 && (<div className="p-2 max-w-7xl mx-auto md:p-4">
            <Breadcrumb items={breadcrumbs}/>
          </div>)}
        <Page page={page} tenant={props.tenant}/>
        <CookieBanner />
        <FaviconHead tenant={props.tenant}/>
        <BackToTop />
        {shouldShowZalo ? (<Zalo locale={locale}/>) : (<FloatingWidget locale={locale}/>)}
        {page.seo && <HeaderMeta {...page.seo}/>}
      </LayoutComponent>
    </div>);
}
async function getStaticProps({ params, locale, }: GetStaticPropsContext) {
    locale = locale || 'th';
    const slugParts = params?.slug as string[];
    const path = slugParts.map((slug) => encodeURI(slug)).join('/');
    let props;
    if (locale === 'th' || locale === 'en') {
        props = await getV1PropsSlugPage(path, locale, ['th', 'en']);
    }
    else {
        props = await getV2PropsSlugPage(path, locale);
    }
    if (!props.page)
        return { notFound: true };
    return {
        props,
        revalidate: process.env.REVALIDATE_MS
            ? parseInt(process.env.REVALIDATE_MS)
            : 60,
    };
}
export async function getStaticPaths(): Promise<GetStaticPathsResult> {
    // Ensure some imporant paths can be rendered while reducing the build time.
    return {
        paths: [
            { params: { slug: ['car-insurance'] }, locale: 'th' },
            { params: { slug: ['car-insurance'] }, locale: 'en' },
            { params: { slug: ['car-insurance'] }, locale: 'en-MY' },
            { params: { slug: ['car-insurance', 'type1'] }, locale: 'th' },
            { params: { slug: ['car-insurance', 'type1'] }, locale: 'en' },
            { params: { slug: ['car-insurance', 'type2'] }, locale: 'th' },
            { params: { slug: ['car-insurance', 'type2'] }, locale: 'en' },
            { params: { slug: ['car-insurance', 'type2-plus'] }, locale: 'th' },
            { params: { slug: ['car-insurance', 'type2-plus'] }, locale: 'en' },
            { params: { slug: ['car-insurance', 'type3'] }, locale: 'th' },
            { params: { slug: ['car-insurance', 'type3'] }, locale: 'en' },
            { params: { slug: ['car-insurance', 'type3-plus'] }, locale: 'th' },
            { params: { slug: ['car-insurance', 'type3-plus'] }, locale: 'en' },
            { params: { slug: ['health-insurance'] }, locale: 'th' },
            { params: { slug: ['credit-card'] }, locale: 'th' },
            { params: { slug: ['credit-card'] }, locale: 'en-SG' },
            { params: { slug: ['san-pham-bao-hiem'] }, locale: 'vi' },
            { params: { slug: ['personal-loan'] }, locale: 'en-PH' },
        ],
        fallback: 'blocking',
    };
}
export default SlugPage;

    async function __Next_Translate__getStaticProps__197200fd925__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[...slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197200fd925__ as getStaticProps }
  